const ITEMS = [
    "Autolavaggi Christ Wash Systems",
    "Concessionario Ufficiale Calabria",
    "Attrezzature Officina Ravaglioli",
    "Assistenza Tecnica 48–72h",
    "Ricambi Originali",
    "Presenti in tutto il Sud Italia",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="font-display px-8 text-sm font-bold uppercase tracking-[0.22em] text-white/75 sm:text-base">
                    {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-[#E30613]" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="brand-marquee"
        className="overflow-hidden border-y border-white/10 bg-[#0B1F3A] py-5"
    >
        <div className="marquee-track">
            <Row />
            <Row />
        </div>
    </div>
);
